module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"groupByTypes":{"carrier":"Energieträger","usage":"Verwendungszweck"},"units":{"s12e":"t","s123e":"t","s1e":"t","s2e":"t","s3e":"t","ee":"MWh","pe":"MWh","penr":"MWh","per":"MWh"}}}')
  delete Component.options._Ctor
}
